import styled from 'styled-components';
import { PRIMARY_COLOR, SECONDARY_COLOR, SEMI_FONT_WEIGHT, SM_FONT_SIZE, WHITE_COLOR } from '../Common/StyleElement';

export const BtnText = styled.span`
    ${props =>
        props.disabled ?
            `color: #ABABAB`
            :
            props.fill ?
                `color: ${WHITE_COLOR};
                    `
                :
                `background-image: linear-gradient(to right, ${PRIMARY_COLOR}, ${SECONDARY_COLOR});
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    `
    }
`

export const Btn = styled.span`
    display: flex;
    position: relative;
    font-size: ${SM_FONT_SIZE};
    font-weight: ${SEMI_FONT_WEIGHT};
    z-index: 1;
    transition: all cubic-bezier(0.19, 1, 0.22, 1) 0.6s;
    overflow: hidden;
    border-radius: 10px;
    justify-content: center;

    ${props =>
        props.disabled ?
            `padding: 0.6rem 1.6rem;
            background: #EEEEEE;
            cursor: default;
            `
            :
            props.fill ?
                `cursor: pointer;
                padding: 0.6rem 1.6rem;
            background-size: 200% auto;
            background-image: linear-gradient(to right, ${PRIMARY_COLOR} 0%, ${SECONDARY_COLOR} 51%, ${PRIMARY_COLOR} 100%);
            
            &:hover {
                background-position: right center;
            }
            `
                :
                `cursor: pointer;
                padding: 0.4rem 1.6rem;
            border: double 2px transparent;
            background-image: linear-gradient(white, white), linear-gradient(to right, ${PRIMARY_COLOR}, ${SECONDARY_COLOR});
            background-origin: border-box;
            background-clip: padding-box, border-box;

            &:after {
                content: '';
                display: block;
                position: absolute;
                border-radius: 7px;
                width: 0;
                height: 100%;
                left: 0;
                bottom: 0;
                z-index: -1;
                transition: all cubic-bezier(0.19, 1, 0.22, 1) 0.3s;
                background-image: linear-gradient(to right, ${PRIMARY_COLOR}, ${SECONDARY_COLOR});
            }

            &:hover {
                &:after {
                    width: 100%;
                }
            }

            &:hover ${BtnText} {
                -webkit-text-fill-color: ${WHITE_COLOR};
                text-decoration: none;
            }
            `
    }
`